import { Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Login from "../../components/Login";

export default function Index() {
  const { t } = useTranslation("index");

  return (
    <div className="index">
      <Container sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} maxWidth="lg">
        <Typography variant="h1">{t("title")}</Typography>
        <Login />
        <div style={{ marginBottom: "100px" }}></div>
      </Container>
    </div>
  );
}
